export default "__VITE_ASSET__DaA3aihL__"